import {ascend, sortWith} from 'ramda';

import type {
  ConfiguratorBundleResponseBody,
  ConfiguratorEngineResponseBody,
  ConfiguratorVariantResponseBody,
} from '@dms/api/new-vehicle';

type TrimEngine = {
  variant: ConfiguratorVariantResponseBody;
  engine: ConfiguratorEngineResponseBody;
};

/** Enabled variants of a trim with their engines, ascending by power, then variant price. */
export const getTrimEngines = (
  bundle: ConfiguratorBundleResponseBody | undefined,
  trimId: string
) =>
  sortWith<TrimEngine>(
    [
      ascend(({engine}) => Number(engine.powerKw)),
      ascend(({variant}) => Number(variant.priceNet)),
      ascend(({variant}) => variant.id),
    ],
    (bundle?.variants ?? [])
      .filter((variant) => variant.trimId === trimId && variant.enabled)
      .flatMap((variant) => {
        const engine = bundle?.engines.find(({id}) => id === variant.engineId);
        return engine ? [{variant, engine}] : [];
      })
  );
